import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  IconButton,
  TablePagination,
  Grid,
  Box,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import './LicenseList.css'; // Import the CSS file
import AddButton from '../../Common_Components/AddButton';
import { useNavigate } from 'react-router-dom';
import { Delete, Edit, Visibility } from '@mui/icons-material';
import { MdMoreHoriz } from 'react-icons/md';
import FilterModal from '../../Common_Components/FilterModal';
import AddLicenseModal from './AddLicenseModal';
import LicenseViewModal from './LicenseViewModal';
import axiosInstance from '../../axios/axios';
import moment from 'moment/moment';
import { hasPrivilege } from '../UserRole/PrevilegeCheck';
import CustomSelectBox from '../../Common_Components/CustomSelectBox';
import SaveButton from '../../Common_Components/SaveButton';
import ResetButton from '../../Common_Components/ResetButton';
const style = {
  fontFamily: 'Times New Roman',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '18.4px',
  color: '#000000',
  alignItems: 'center'
}
const tableHeaderStyle = {
  fontFamily: 'Times New Roman',
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '18.4px',
  color: '#302D2D'
}
const ViewStyle = {
  color: '#72E463', // Customize the color of the text
  fontFamily: 'Josefin Sans, sans-serif', // Set the font family
  fontWeight: 400, // Set font weight
  textAlign: 'center', // Center text
  padding: '12px 12px', // Custom padding
  '& .MuiSvgIcon-root': {
    color: '#72E463', // Customize the color of the icon
  },
}
const editStyle = {
  color: '#FFC575', // Customize the color of the text
  fontFamily: 'Josefin Sans, sans-serif', // Set the font family
  fontWeight: 400, // Set font weight
  textAlign: 'center', // Center text
  padding: '12px 12px', // Custom padding
  '& .MuiSvgIcon-root': {
    color: '#FFC575', // Customize the color of the icon
  },
}

const deleteStyle = {
  color: '#FF7575', // Customize the color of the text
  fontFamily: 'Josefin Sans, sans-serif', // Set the font family
  fontWeight: 400, // Set font weight
  textAlign: 'center', // Center text
  padding: '12px 12px', // Custom padding
  '& .MuiSvgIcon-root': {
    color: '#FF7575', // Customize the color of the icon
  },
}
const LicenseList = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [open, setOpen] = useState(false);
  const [open_addlicense, setopen_addlicene] = useState(false)
  const [open_viewlicense, setopen_viewlicene] = useState(false)
  const [render, setRender] = useState(0)
  //for opening and closing filter modal
  const handleOpen = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  //for opening and closing add license modal
  const handleOpenlicense = () => setopen_addlicene(true);
  const handleCloseLicenseModal = () => {
    setRender(render + 1)
    setopen_addlicene(false)

  };
  //for opening and closing view license modal
  const handleOpenviewlicense = () => setopen_viewlicene(true);
  const handleCloseviewLicenseModal = () => setopen_viewlicene(false);
  const [licenses, setlicenses] = useState([])
  const [licensedetl, setlicenseDetl] = useState('')
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [clientLists, setClientLists] = useState([])
  const [selectedClient, setSelectedClient] = useState(null)
  const [productLists, setProductLists] = useState([])
  const [selectedProductid, setSelectedproductid] = useState(null)
  const [licenseTypeLists, setLicenseTypeList] = useState([])
  const [licenseType, setLicenseType] = useState(null)
  const [status, setStatus] = useState(null)
  const statusList = [
    { id: 1, label: 'Issued' },
    { id: 2, label: 'Activated' },
    { id: 3, label: 'Expired' }
  ];
  //for opening context menu
  const handleClick = (event, product) => {
    setlicenseDetl(product)
    setAnchorEl(event.currentTarget);
    setSelectedProduct(product); // Store the selected product
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleView = (value) => {
    handleOpenviewlicense()
    // setlicenseDetl(value)
    handleClose();
  };

  const handlenavigatetoAdd = async () => {
    handleOpenlicense()
  }
  useEffect(() => {
    const getClientList = async () => {
      const response = await axiosInstance.post('/clients/clientList')
      const { success, clients } = response.data
      if (success === true) {
        const vals = clients && clients.map((val) => {
          return { id: val.CD_Id, label: val.CD_Name }
        })
        setClientLists(vals)
      } else {
        setClientLists([])
      }
    }
    const getProductList = async () => {
      const response = await axiosInstance.post('/product/List')
      const { success, products } = response.data
      if (success === true) {
        const vals = products && products.map((val) => {
          return { id: val.PD_Id, label: val.PD_Name }
        })
        setProductLists(vals)
      } else {
        setProductLists([])
      }
    }
    const fetchLicenseTypes = async () => {
      try {
        const response = await axiosInstance.get('/common/licenseTypes');
        const { success, LicenseTypeList } = response.data
        if (success === true) {
          const vals = LicenseTypeList && LicenseTypeList.map((val) => {
            return { id: val.LT_Id, label: val.LT_Name }
          })
          setLicenseTypeList(vals)
        } else {
          setLicenseTypeList([])
        }
      } catch (error) {
        console.error('Error fetching countries:', error);
        // Toast.error('Failed to fetch countries.');
      }
    };
    getProductList()
    getClientList()
    fetchLicenseTypes()
  }, [])
  //get license
  const getLicenselist = async () => {
    const response = await axiosInstance.post('/licenses')
    const { success, licenses } = response.data
    if (success === true) {
      setlicenses(licenses)
    } else {
      setlicenses([])
    }
  }
  const fetchLicenseFilter = async () => {
    const filtersreq = {
      clientId: selectedClient?.id,
      productId: selectedProductid?.id,
      licenseTypeId: licenseType?.id,
      status: status?.id,
    }
    const response = await axiosInstance.post('/licenses', filtersreq)
    const { success, licenses } = response.data
    if (success === true) {
      setlicenses(licenses)
    } else {
      setlicenses([])
    }
  }

  const handleSearch = () => {
    fetchLicenseFilter();
  };
  useEffect(() => {
    getLicenselist()
  }, [render])

  const handleReset = () => {
    setSelectedClient(null)
    setSelectedproductid(null)
    setLicenseType(null)
    setStatus(null)
    getLicenselist();
  };



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div className="license-management">
      <FilterModal open={open} handleClose={handleCloseModal} />
      <AddLicenseModal open={open_addlicense} handleClose={handleCloseLicenseModal} />
      <LicenseViewModal open={open_viewlicense} handleClose={handleCloseviewLicenseModal} licensedetl={licensedetl} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 className='license-ttitle'>License Management</h2>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* <IconButton
            aria-label="filter"
            sx={{
              border: '2px solid #5C3685',
              borderRadius: '8px',
              padding: '5px',
              marginRight: '10px'
            }}
          >
            <FilterListIcon sx={{ color: '#5C3685' }} onClick={handleOpen} />
          </IconButton> */}
          {
            hasPrivilege('Add license') && <AddButton onClick={handlenavigatetoAdd} />
          }
        </div>
      </div>
      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} md={2}>
          <CustomSelectBox
            label="Client"
            options={clientLists}
            Value={selectedClient}
            setValue={setSelectedClient}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomSelectBox
            label="Product"
            options={productLists}
            Value={selectedProductid}
            setValue={setSelectedproductid}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomSelectBox
            label="License Type"
            options={licenseTypeLists}
            Value={licenseType}
            setValue={setLicenseType}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomSelectBox
            label="Status"
            options={statusList}
            Value={status}
            setValue={setStatus}
          />
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={2}
          sx={{ mt: 4 }}
          alignItems="center"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "left", // Controls button placement
              gap: 2, // Minimal gap between buttons
              width: "100%",
            }}
          >
            <SaveButton label="Search" onClick={handleSearch} fullWidth={false} />
            <ResetButton label="Reset" onClick={handleReset} fullWidth={false} />
          </Box>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{ backgroundColor: '#EEDEFF' }}>
            <TableRow>
              <TableCell sx={tableHeaderStyle}>Sl no</TableCell>
              <TableCell sx={tableHeaderStyle}>Client Name</TableCell>
              <TableCell sx={tableHeaderStyle}>Product Name</TableCell>
              <TableCell sx={tableHeaderStyle}>Product Version</TableCell>
              <TableCell sx={tableHeaderStyle}>License Type</TableCell>
              <TableCell sx={tableHeaderStyle}>User Count</TableCell>
              <TableCell sx={tableHeaderStyle}>Issued Date</TableCell>
              <TableCell sx={tableHeaderStyle}>Activated Date</TableCell>
              <TableCell sx={tableHeaderStyle}>Expiry Date</TableCell>
              <TableCell sx={tableHeaderStyle}>License Status</TableCell>
              <TableCell sx={tableHeaderStyle}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {licenses && licenses.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((license, index) => (
                <TableRow key={index + 1} style={{ backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#DAD9D9' }}>
                  <TableCell sx={style}>{index + 1}</TableCell>
                  <TableCell sx={style}>{license.ClientName}</TableCell>
                  <TableCell sx={style}>{license.ProductName}</TableCell>
                  <TableCell sx={style}>{license.Version}</TableCell>
                  <TableCell sx={style}>{license.LicenseTypeName}</TableCell>
                  <TableCell sx={style}>{license.UserLicenseCount}</TableCell>
                  <TableCell sx={style}>{moment(license.CreatedDate).format('DD-MM-YYYY')}</TableCell>
                  <TableCell sx={style}>{license.ActivatedDate === null ? '-' : moment(license.ActivatedDate).format('DD-MM-YYYY')}</TableCell>
                  <TableCell sx={style}>{moment(license.ExpiryDate).format('DD-MM-YYYY')}</TableCell>
                  <TableCell sx={style}>{license.Status}</TableCell>
                  <TableCell>
                    <MdMoreHoriz size={30} onClick={(event) => handleClick(event, license)} />
                    <Menu
                      id="action-menu"
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      sx={{
                        width: '293px',
                        '& .MuiMenuItem-root': {
                          minWidth: '200px', // Increase the size of each menu item
                          borderBottom: '1px solid #e0e0e0', // Underline after each item
                          '&:last-child': {
                            borderBottom: 'none', // Remove underline from the last item
                          },
                        },
                      }}
                    >
                      {
                        hasPrivilege('View License') && <MenuItem onClick={(e) => handleView(license)} sx={ViewStyle}>
                          <Visibility sx={{ mr: 1 }} /> View
                        </MenuItem>
                      }

                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={licenses.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </div>

  )
}

export default LicenseList